import classes from './loadingTwo.module.css'
const LoadingTwo = () => {
    return (
        <div className='loadingContainer'>
            <div className={classes.line}>
                <div className={classes.hexagon}></div>
            </div>
        </div>
    )
}

export default LoadingTwo
